import React, { Component, Fragment } from "react";
import OsobeSearch from "../../components/PregledSearch/OsobeSearch";
import OsobeTable from "../../components/PregledTable/OsobeTable";
import OsobeDrustvaTreceZemljeTable from "../../components/PregledTable/OsobeDrustvaTreceZemljeTable";
import axios from "../../api/utils/axiosInstance";
import DrustvaSearch from "../../components/PregledSearch/DrustvaSearch";
import DrustvaTable from "../../components/PregledTable/DrustvaTable";
import Modal from "../../components/UI/Modal/Modal";
import SamostalniRevizorDetaljiTable from "../../components/DetaljiTable/SamostalniRevizorDetaljiTable";
import { GET_OSOBA, GET_DRUSTVO } from "../../constants/constants";
import { connect } from "react-redux";
import RevizorskaDrustvaDetaljiTable from "../../components/DetaljiTable/RevizorskaDrustvaDetaljiTable";
import OvlasteniRevizoriDetaljiTable from "../../components/DetaljiTable/OvlasteniRevizoriDetaljiTable";
import RevizorskiVjezbeniciDetaljiTable from "../../components/DetaljiTable/RevizorskiVjezbeniciDetaljiTable";
import RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable from "../../components/DetaljiTable/RevizorskaDrustvaDrugihDrzavaClanica";
import OvlasteniRevizoriDrugihDrzavaDetaljiTable from "../../components/DetaljiTable/OvlasteniRevizoriDrugihDrzavaDetaljiTable";
import OvlasteniRevizoriIzTrecihZemaljaDetaljiTable from "../../components/DetaljiTable/OvlasteniRevizoriIzTrecihZemaljaDetaljiTable";
import SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable from "../../components/DetaljiTable/SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { Container, Row, Col, Table } from "react-bootstrap";
import { Pagination } from "antd";
import Spinner from "react-bootstrap/Spinner";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import { toast } from "react-toastify";
import axiosInstance from "../../api/utils/axiosInstance";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

import ReactToPrint from "react-to-print";
import InputComponent from "../../components/UI/InputComponent/InputComponent";

class PregledRegistra extends Component {
  state = {
    biljeska: "",
    data: [],
    dataFiltered: [],
    detaljiData: [],
    povijestData: [],
    secondaryDetaljiData: [],
    totalPageCount: 0,
    registriSearchModel: {
      formId: null,
      pojam: "",
      nazSubjekta: null,
      oib: null,
      regBroj: null,
      ime: null,
      prezime: null,
      drzava: null,
      pageNumber: 1,
      offset: 50,
      isSingla: true,
      tipSubjekta: "sve",
    },
    modalVisible: false,
    secondaryModalVisible: false,
    deactivateModalVisible: false,
    activateModalVisible: false,
    azurirajModalVisible: false,
    povijestModalVisible: false,
    idSubjekta: null,
    vrSubjekta: null,
    nazivSubjekta: null,
    deaktivacijaSubjekt: "",
    deaktivacijaIdSubjekta: null,
    deaktivacijaVrSubjekta: null,
    deaktivacijaZahtjevAtrId: null,
    aktivacijaSubjekt: "",
    aktivacijaIdSubjekta: null,
    aktivacijaVrSubjekta: null,
    aktivacijaZahtjevAtrId: null,
    azuriranjeData: [],
    isLoading: false,
    secondaryVrSubjekta: null,
    vrstaSubjekta: "",
    filterDropdownValue: "sve",
  };
  ref = React.createRef();

  componentDidMount() {
    const userData = this.props?.userData ?? null;
    const userRole = userData?.roles?.[0]?.roleName ?? null;
    const formId = this.props?.match?.params?.formId ?? null;
    const isUserSluzbenik = userRole === "ROLE_SLUZBENIK";
    
    // Redirect if user is not sluzbenik and trying to access registar revizorskih vjezbenika
    if(!isUserSluzbenik && formId === "4") {
      this.props.history.push(
          `/pregled-registara`
        );
    }
    
    this.setState(
      {
        registriSearchModel: {
          ...this.state.registriSearchModel,
          formId: this.props.match.params.formId,
        },
      },
      () => {
        axios
          .post("/findRegistar", {
            ...this.state.registriSearchModel,
            tipSubjekta: this.state.filterDropdownValue,
          })
          .then((res) => {
            this.setState({
              data: res.data.result,
              dataFiltered: res.data.result,
              totalPageCount: res.data.size,
            });
          });
      }
    );
  }

  onOsobeSearchChanged = (e) => {
    let pojam = String(e.target.value).trim().toLowerCase();

    this.setState({
      registriSearchModel: {
        ...this.state.registriSearchModel,
        pojam: pojam,
        prezime: pojam,
        ime: pojam,
        regBroj: pojam,
      },
    });
  };

  onDrustvaSearchChanged = (e) => {
    let pojam = String(e.target.value).trim().toLowerCase();

    this.setState(
      {
        registriSearchModel: {
          ...this.state.registriSearchModel,
          pojam: pojam,
          nazSubjekta: pojam,
          ime: pojam,
          prezime: pojam,
          regBroj: pojam,
          oib: pojam,
        },
      },
      () => {}
    );
  };

  azurirajClicked = (e, id, vrsta, brReg) => {
    e.preventDefault();

    axios.get(`/data-change-requests?brReg=${brReg}`).then((res) => {
      this.setState({
        idSubjekta: id,
        vrSubjekta: vrsta,
        azurirajModalVisible: true,
        azuriranjeData: res.data,
      });
    });
  };

  deaktivirajClicked = (subjekt, idSubjekta, vrSubjekta) => {
    this.setState({
      deactivateModalVisible: true,
      deaktivacijaSubjekt: subjekt,
      deaktivacijaIdSubjekta: idSubjekta,
      deaktivacijaVrSubjekta: vrSubjekta,
    });
  };

  aktivirajClicked = (subjekt, idSubjekta, vrSubjekta) => {
    this.setState({
      activateModalVisible: true,
      aktivacijaSubjekt: subjekt,
      aktivacijaIdSubjekta: idSubjekta,
      aktivacijaVrSubjekta: vrSubjekta,
    });
  };

  deaktivirajTrecuZemljuClicked = (
    subjekt,
    idSubjekta,
    deaktivacijaZahtjevAtrId
  ) => {
    this.setState({
      deactivateModalVisible: true,
      deaktivacijaSubjekt: subjekt,
      deaktivacijaIdSubjekta: idSubjekta,
      deaktivacijaZahtjevAtrId: deaktivacijaZahtjevAtrId,
    });
  };

  aktivirajTrecuZemljuClicked = (
    subjekt,
    idSubjekta,
    aktivacijaZahtjevAtrId
  ) => {
    this.setState({
      activateModalVisible: true,
      aktivacijaSubjekt: subjekt,
      aktivacijaIdSubjekta: idSubjekta,
      aktivacijaZahtjevAtrId: aktivacijaZahtjevAtrId,
    });
  };

  deactivateSubjekt = () => {
    let url = "";

    switch (this.state.deaktivacijaSubjekt) {
      case "osoba":
        url = `/deactivateOsoba/` + this.state.deaktivacijaIdSubjekta;
        break;
      case "drustvo":
        url =
          "/deactivateDrustvo/" +
          this.state.deaktivacijaVrSubjekta +
          "/" +
          this.state.deaktivacijaIdSubjekta;
        break;
      case "trecaZemljaOsoba":
        url =
          "/deactivateTrecaZemlja?tip=osoba&id=" +
          this.state.deaktivacijaIdSubjekta +
          "&zahtjevAtrId=" +
          this.state.deaktivacijaZahtjevAtrId;
        break;
      case "trecaZemljaDrustvo":
        url =
          "/deactivateTrecaZemlja?tip=drustvo&id=" +
          this.state.deaktivacijaIdSubjekta +
          "&zahtjevAtrId=" +
          this.state.deaktivacijaZahtjevAtrId;
        break;
      default:
        break;
    }
    axios
      .patch(url, JSON.stringify({ biljeska: this.state.biljeska }))
      .then((res) => {
        this.hideModal("deaktivacija");
        toast.success("Subjekt uspješno brisan.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        // window.location.reload();
        axios
          .post("/findRegistar", {
            ...this.state.registriSearchModel,
            tipSubjekta: this.state.filterDropdownValue,
          })
          .then((res) => {
            this.setState({
              data: res.data.result,
              totalPageCount: res.data.size,
              dataFiltered: res.data.result,
              biljeska: "",
            });
          });
      });
  };

  activateSubjekt = () => {
    let url = "";

    switch (this.state.aktivacijaSubjekt) {
      case "osoba":
        url = `/activateOsoba/` + this.state.aktivacijaIdSubjekta;
        break;
      case "drustvo":
        url = "/activateDrustvo/" + this.state.aktivacijaIdSubjekta;
        break;
      case "trecaZemljaOsoba":
        url =
          "/activateTrecaZemlja?tip=osoba&id=" +
          this.state.aktivacijaIdSubjekta +
          "&zahtjevAtrId=" +
          this.state.aktivacijaZahtjevAtrId;
        break;
      case "trecaZemljaDrustvo":
        url =
          "/activateTrecaZemlja?tip=drustvo&id=" +
          this.state.aktivacijaIdSubjekta +
          "&zahtjevAtrId=" +
          this.state.aktivacijaZahtjevAtrId;
        break;
      default:
        break;
    }
    axios
      .patch(url, JSON.stringify({ biljeska: this.state.biljeska }))
      .then((res) => {
        this.hideModal("aktivacija");
        toast.success("Subjekt uspješno aktiviran.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        // window.location.reload();
        axios
          .post("/findRegistar", {
            ...this.state.registriSearchModel,
            tipSubjekta: this.state.filterDropdownValue,
          })
          .then((res) => {
            this.setState({
              data: res.data.result,
              totalPageCount: res.data.size,
              dataFiltered: res.data.result,
              biljeska: "",
            });
          });
      });
  };

  onSearchSubmitted = (e) => {
    if (
      this.state.registriSearchModel.pojam.length == 0 ||
      this.state.registriSearchModel.pojam.length >= 3
    ) {
      this.setState(
        {
          isLoading: true,
          registriSearchModel: {
            ...this.state.registriSearchModel,
            pageNumber: 1,
          },
        },
        () => {
          axios
            .post("/findRegistar", this.state.registriSearchModel)
            .then((res) => {
              this.setState({
                data: res.data.result,
                dataFiltered: res.data.result,
                totalPageCount: res.data.size,
                isLoading: false,
                pageNumber: 1,
                filterDropdownValue: "sve",
              });
            });
        }
      );
    } else {
      toast.info("Morate unijeti minimalno 3 znaka.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  getDetaljiTable = (index) => {
    let formId = this.state.registriSearchModel.formId;
    if (formId == 3) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <SamostalniRevizorDetaljiTable
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            userRole={userRole}
          >
            {this.state.detaljiData}
          </SamostalniRevizorDetaljiTable>
        </div>
      );
    } else if (formId == 2) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <RevizorskaDrustvaDetaljiTable
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            userRole={userRole}
          >
            {this.state.detaljiData}
          </RevizorskaDrustvaDetaljiTable>
        </div>
      );
    } else if (formId == 1 && this.state.idSubjekta) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <OvlasteniRevizoriDetaljiTable
            detaljiClicked={this.detaljiClicked}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            userRole={userRole}
          >
            {this.state.detaljiData}
          </OvlasteniRevizoriDetaljiTable>
        </div>
      );
    } else if (formId == 4) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <RevizorskiVjezbeniciDetaljiTable
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.detaljiData}
          </RevizorskiVjezbeniciDetaljiTable>
        </div>
      );
    } else if (formId == 5) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            userRole={userRole}
          >
            {this.state.detaljiData}
          </RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable>
        </div>
      );
    } else if (formId == 6) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <OvlasteniRevizoriDrugihDrzavaDetaljiTable
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            userRole={userRole}
          >
            {this.state.detaljiData}
          </OvlasteniRevizoriDrugihDrzavaDetaljiTable>
        </div>
      );
    } else if (formId == 7) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            userRole={userRole}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
          >
            {this.state.detaljiData}
          </SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable>
        </div>
      );
    } else if (formId == 8) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <OvlasteniRevizoriIzTrecihZemaljaDetaljiTable
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            userRole={userRole}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
          >
            {this.state.detaljiData}
          </OvlasteniRevizoriIzTrecihZemaljaDetaljiTable>
        </div>
      );
    } else return null;
  };

  getSecondaryDetaljiTable = () => {
    if (
      this.state.vrstaSubjekta === "drustvo" &&
      this.state.secondaryVrSubjekta == 1
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <RevizorskaDrustvaDetaljiTable
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </RevizorskaDrustvaDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "drustvo" &&
      this.state.secondaryVrSubjekta == 2
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <SamostalniRevizorDetaljiTable
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </SamostalniRevizorDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "drustvo" &&
      this.state.secondaryVrSubjekta == 3
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </RevizorskaDrustvaDrugihDrzavaClanicaDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "drustvo" &&
      this.state.secondaryVrSubjekta == 4
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable
            downloadDocumentUSDrustvo={this.downloadDocumentUSDrustvo}
            downloadDocumentPPDrustvo={this.downloadDocumentPPDrustvo}
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentDrustvo={this.downloadDocumentDrustvo}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "osoba" &&
      this.state.secondaryVrSubjekta === 1
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <OvlasteniRevizoriDetaljiTable
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </OvlasteniRevizoriDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "osoba" &&
      this.state.secondaryVrSubjekta === 2
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <RevizorskiVjezbeniciDetaljiTable
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </RevizorskiVjezbeniciDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "osoba" &&
      this.state.secondaryVrSubjekta === 3
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <OvlasteniRevizoriDrugihDrzavaDetaljiTable
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </OvlasteniRevizoriDrugihDrzavaDetaljiTable>
        </div>
      );
    } else if (
      this.state.vrstaSubjekta === "osoba" &&
      this.state.secondaryVrSubjekta === 4
    ) {
      const { userData } = this.props;
      const userRole = userData != null ? userData.roles[0].roleName : null;
      return (
        <div>
          <OvlasteniRevizoriIzTrecihZemaljaDetaljiTable
            downloadDocumentUSOsoba={this.downloadDocumentUSOsoba}
            downloadDocumentPPOsoba={this.downloadDocumentPPOsoba}
            downloadDocumentOsoba={this.downloadDocumentOsoba}
            detaljiSecondaryClicked={this.detaljiSecondaryClicked}
            userRole={userRole}
          >
            {this.state.secondaryDetaljiData}
          </OvlasteniRevizoriIzTrecihZemaljaDetaljiTable>
        </div>
      );
    }
  };

  hideSecondaryModal = () => {
    this.setState({
      secondaryModalVisible: false,
    });
  };

  detaljiClicked = (idSubjekta, vrSubjekta, action, showHistory) => {
    let url =
      action == "osoba"
        ? "/findOsoba?vrOsobe=" +
          vrSubjekta +
          "&idOsobe=" +
          idSubjekta +
          "&showHistory=" +
          showHistory.toString()
        : "/findDrustvo?vrDrustva=" +
          vrSubjekta +
          "&idDrustva=" +
          idSubjekta +
          "&showHistory=" +
          showHistory.toString();

    axios.get(url).then((res) => {
      this.setState({
        modalVisible: true,
        idSubjekta: idSubjekta,
        vrSubjekta: vrSubjekta,
        nazivSubjekta: action,
        detaljiData: res.data,
      });
    });
  };

  povijestClicked = (regBroj, action) => {
    let url =
      action == "osoba"
        ? "/findChangeHistory?regBroj=" + regBroj + "&subjekt=" + "osoba"
        : "/findChangeHistory?regBroj=" + regBroj + "&subjekt=" + "drustvo";

    axios.get(url).then((res) => {
      this.setState({
        povijestModalVisible: true,
        povijestData: res.data,
      });
    });
  };

  detaljiSecondaryClicked = (subjekt, idSubjekta, vrSubjekta, showHistory) => {
    let url;
    if (subjekt === "osoba") {
      url = `/findOsoba?idOsobe=${idSubjekta}&vrOsobe=${vrSubjekta}&showHistory=${showHistory.toString()}`;
    } else {
      url = `/findDrustvo?idDrustva=${idSubjekta}&vrDrustva=${vrSubjekta}&showHistory=${showHistory.toString()}`;
    }

    axios.get(url).then((res) => {
      this.setState({
        secondaryModalVisible: true,
        secondaryDetaljiData: res.data,
        vrstaSubjekta: subjekt,
        secondaryVrSubjekta: vrSubjekta,
      });
    });
  };

  hideModal = (modalType) => {
    if (modalType == "azuriranje")
      this.setState({
        azurirajModalVisible: false,
        idSubjekta: null,
        vrSubjekta: null,
      });
    else if (modalType == "deaktivacija")
      this.setState({
        deactivateModalVisible: false,
        biljeska: "",
      });
    else if (modalType == "aktivacija")
      this.setState({
        activateModalVisible: false,
      });
    else if (modalType == "detalji")
      axios
        .post("/findRegistar",{ ...this.state.registriSearchModel, tipSubjekta: this.state.filterDropdownValue})
        .then((res) => {
          this.setState({
            data: res.data.result,
            totalPageCount: res.data.size,
          });
        });
    else if (modalType == "povijest") {
      this.setState({
        povijestModalVisible: false,
        idSubjekta: null,
        vrSubjekta: null,
      });
    }

    this.setState({
      modalVisible: false,
      idSubjekta: null,
      vrSubjekta: null,
    });
  };

  redirectToAzurirajPoZahtjevu = (e, id, vrsta, oznDokumenta) => {
    switch (this.props.match.params.formId) {
      case "1":
        this.props.dispatchOsoba(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-ovlastenih-revizora/${id}`
        );
        break;
      case "2":
        this.props.dispatchDrustvo(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-revizorskih-drustava/${id}`
        );
        break;
      case "3":
        this.props.dispatchDrustvo(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-samostalnih-revizora/${id}`
        );
        break;
      case "4":
        this.props.dispatchOsoba(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-revizorskih-vjezbenika/${id}`
        );
        break;
      case "5":
        this.props.dispatchDrustvo(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-revizorskih-drustava-iz-drugih-drzava-clanica/${id}`
        );
        break;
      case "6":
        this.props.dispatchOsoba(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-ovlastenih-revizora-iz-drugih-drzava-clanica/${id}`
        );
        break;
      case "7":
        this.props.dispatchDrustvo(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji/${id}`
        );
        break;
      case "8":
        this.props.dispatchOsoba(id, vrsta, oznDokumenta);
        this.props.history.push(
          `/azuriraj-po-zahtjevu/registar-ovlastenih-revizora-iz-trecih-zemalja/${id}`
        );
        break;
    }
  };

  redirectHandler = (e, id, vrsta) => {
    e.preventDefault();
    switch (this.props.match.params.formId) {
      case "1":
        this.props.dispatchOsoba(id, vrsta);
        this.props.history.push(`/azuriraj/registar-ovlastenih-revizora/${id}`);
        break;
      case "2":
        this.props.dispatchDrustvo(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-revizorskih-drustava/${id}`
        );
        break;
      case "3":
        this.props.dispatchDrustvo(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-samostalnih-revizora/${id}`
        );
        break;
      case "4":
        this.props.dispatchOsoba(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-revizorskih-vjezbenika/${id}`
        );
        break;
      case "5":
        this.props.dispatchDrustvo(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-revizorskih-drustava-iz-drugih-drzava-clanica/${id}`
        );
        break;
      case "6":
        this.props.dispatchOsoba(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-ovlastenih-revizora-iz-drugih-drzava-clanica/${id}`
        );
        break;
      case "7":
        this.props.dispatchDrustvo(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-subjekata-za-obavljanje-revizije-u-trecoj-zemlji-i-registar-revizora-u-trecoj-zemlji/${id}`
        );
        break;
      case "8":
        this.props.dispatchOsoba(id, vrsta);
        this.props.history.push(
          `/azuriraj/registar-ovlastenih-revizora-iz-trecih-zemalja/${id}`
        );
        break;
    }
  };

  pageChanged = (pageNumber, pageSize) => {
    this.setState(
      {
        isLoading: true,
        registriSearchModel: {
          ...this.state.registriSearchModel,
          pageNumber: pageNumber,
          filterDropdownValue: this.state.filterDropdownValue,
        },
      },
      () => {
        axios
          .post("/findRegistar", {...this.state.registriSearchModel, tipSubjekta: this.state.filterDropdownValue})
          .then((res) => {
            this.setState({
              data: res.data.result,
              dataFiltered: res.data.result,
              totalPageCount: res.data.size,
              pageNumber: pageNumber,
              isLoading: false,
            });
          });
      }
    );
  };

  onEnterPressed = (e) => {
    if (e.charCode == 13) {
      this.onSearchSubmitted();
    }
  };

  //download dokumenta
  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };
  downloadDocumentUSOsoba = (e, idMjereOsobe) => {
    axiosInstance
      .get(
        `/controlMeasures/pregledRegistara/print/printDocument?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=2`
      )
      .then((response) => {
        if (response.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(response.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idMjereOsobe + "_upravni_spor." + response.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };
  downloadDocumentPPOsoba = (e, idMjereOsobe) => {
    axiosInstance
      .get(
        `/controlMeasures/pregledRegistara/print/printDocument?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=3`
      )
      .then((response) => {
        if (response.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(response.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idMjereOsobe + "_prekrsajni_postupak." + response.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };

  downloadDocumentUSDrustvo = (e, idMjereDrustva) => {
    axiosInstance
      .get(
        `/controlMeasures/pregledRegistara/print/printDocument?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=2`
      )
      .then((response) => {
        if (response.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(response.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idMjereDrustva + "_upravni_spor." + response.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };
  downloadDocumentPPDrustvo = (e, idMjereDrustva) => {
    axiosInstance
      .get(
        `/controlMeasures/pregledRegistara/print/printDocument?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=3`
      )
      .then((response) => {
        if (response.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(response.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idMjereDrustva + "_prekrsajni_postupak." + response.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };
  downloadDocumentOsoba = (e, idMjereOsobe) => {
    const date = new Date();
    axiosInstance
      .get(
        `/controlMeasures/pregledRegistara/print/printDocument?idMjereSubjekta=${idMjereOsobe}&vrSubjekta=1&vrDokumenta=1`
      )
      .then((response) => {
        if (response.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(response.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idMjereOsobe + "_nadzorna_mjera." + response.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };
  downloadDocumentDrustvo = (e, idMjereDrustva) => {
    const date = new Date();
    axiosInstance
      .get(
        `/controlMeasures/pregledRegistara/print/printDocument?idMjereSubjekta=${idMjereDrustva}&vrSubjekta=2&vrDokumenta=1`
      )

      .then((response) => {
        if (response.data.blob !== null) {
          const url = window.URL.createObjectURL(
            new Blob([this.b64toBlob(response.data.blob)])
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute(
            "download",
            idMjereDrustva + "_nadzorna_mjera." + response.data.extension
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  };

  print() {
    let element = document.getElementById("printArea");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(element.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  onExportRegistar(subjekt, vrSubjekta, nazivRegistra) {
    let url = subjekt == "osoba" ? "osoba" : "drustvo";
    let vrSubj = subjekt == "osoba" ? "vrOsobe" : "vrDrustva";

    axiosInstance
      .get(`/print/csv/${url}?${vrSubj}=${vrSubjekta}`)
      .then((response) => {
        if (response.data !== null) {
          const url = window.URL.createObjectURL(
            new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), response.data], {
              type: "text/csv;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", nazivRegistra + ".csv");
          document.body.appendChild(link);
          link.click();
        } else {
          this.props.formSubmitError(true, "Dokument nije prenesen.");
        }
      });
  }

  handleInputChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
  };

  subjektDropdownChanged = (subjekt) => {
    axios
      .post("/findRegistar", {
        ...this.state.registriSearchModel,
        pageNumber: subjekt === "sve" ? 1 : 1,
        tipSubjekta: subjekt,
      })
      .then((res) => {
        this.setState({
          data: res.data.result,
          registriSearchModel: {
            ...this.state.registriSearchModel,
            pageNumber: 1,
          },
          dataFiltered: res.data.result,
          totalPageCount: res.data.size,
          filterDropdownValue: subjekt,
        });
      });
  };

  render() {
    //drustva

    //REGISTAR_REVIZORSKIH_DRUSTAVA, formId = 2
    //REGISTAR_SAMOSTALNIH_REVIZORA, formId = 3
    //PODACI_U_REGISTRU_REVIZORSKIH_DRUSTAVA_IZ_DRUGIH_DRZAVA_CLANICA, formId = 5
    //PODACI_U_REGISTRU_SUBJEKATA_ZA_OBAVLJANJE_REVIZIJE_U_TRECOJ_ZEMLJI, formId = 7

    //osobe

    //REGISTAR_OVLASTENIH_REVIZORA, formId = 1
    //PODACI_U_REGISTRU_OVLASTENIH_REVIZORA_IZ_DRUGIH_DRZAVA_CLANICA, formId = 6
    //REGISTAR_REVIZORSKIH_VJEZBENIKA, formId = 4
    //PODACI_U_REGISTRU_REVIZORA_U_TRECOJ_ZEMLJI, formId = 8

    const noDataMessage = <i>Nema unesenih podataka.</i>;

    let isOsoba =
      this.props.match.params.formId == 1 ||
      this.props.match.params.formId == 6 ||
      this.props.match.params.formId == 4 ||
      this.props.match.params.formId == 8
        ? true
        : false;

    let isDrustvo =
      this.props.match.params.formId == 2 ||
      this.props.match.params.formId == 3 ||
      this.props.match.params.formId == 5
        ? true
        : false;

    let isTreceZemlje = this.props.match.params.formId == 7 ? true : false;

    const { isAuthenticated, userData } = this.props;
    const userRole = userData != null ? userData.roles[0].roleName : null;

    return (
      <div className="pregled-registara">
        {isOsoba ? (
          <div>
            <OsobeSearch
              onSearchChanged={(e) => this.onOsobeSearchChanged(e)}
              onSearchSubmitted={(e) => this.onSearchSubmitted}
              onEnterPressed={(e) => this.onEnterPressed(e)}
              formId={this.props.match.params.formId}
            ></OsobeSearch>
            <br />
            <br />

            <OsobeTable
              isAuthenticated={this.props.isAuthenticated}
              redirectHandler={this.redirectHandler}
              formId={this.props.match.params.formId}
              detaljiClicked={this.detaljiClicked}
              povijestClicked={this.povijestClicked}
              deaktivirajClicked={this.deaktivirajClicked}
              aktivirajClicked={this.aktivirajClicked}
              azurirajClicked={this.azurirajClicked}
              userRole={userRole}
              exportRegistar={this.onExportRegistar}
            >
              {this.state.data}
            </OsobeTable>
          </div>
        ) : null}

        {isDrustvo ? (
          <div>
            <DrustvaSearch
              onSearchChanged={(e) => this.onDrustvaSearchChanged(e)}
              onSearchSubmitted={(e) => this.onSearchSubmitted}
              onEnterPressed={(e) => this.onEnterPressed(e)}
              formId={this.props.match.params.formId}
            ></DrustvaSearch>
            <br />
            <br />
            <DrustvaTable
              isAuthenticated={this.props.isAuthenticated}
              redirectHandler={this.redirectHandler}
              formId={this.props.match.params.formId}
              detaljiClicked={this.detaljiClicked}
              povijestClicked={this.povijestClicked}
              azurirajPoZahtjevuClick
              deaktivirajClicked={this.deaktivirajClicked}
              aktivirajClicked={this.aktivirajClicked}
              azurirajClicked={this.azurirajClicked}
              userRole={userRole}
              exportRegistar={this.onExportRegistar}
            >
              {this.state.data}
            </DrustvaTable>
          </div>
        ) : null}

        {isTreceZemlje ? (
          <div>
            <DrustvaSearch
              onSearchChanged={(e) => this.onDrustvaSearchChanged(e)}
              onSearchSubmitted={(e) => this.onSearchSubmitted}
              onEnterPressed={(e) => this.onEnterPressed(e)}
              formId={this.props.match.params.formId}
            ></DrustvaSearch>
            <br></br> <br></br>
            <OsobeDrustvaTreceZemljeTable
              isAuthenticated={this.props.isAuthenticated}
              redirectHandler={this.redirectHandler}
              formId={this.props.match.params.formId}
              detaljiClicked={this.detaljiClicked}
              deaktivirajClicked={this.deaktivirajTrecuZemljuClicked}
              aktivirajClicked={this.aktivirajTrecuZemljuClicked}
              povijestClicked={this.povijestClicked}
              azurirajClicked={this.azurirajClicked}
              userRole={userRole}
              exportRegistar={this.onExportRegistar}
              subjektDropdownChanged={this.subjektDropdownChanged}
              filterDropdownValue={this.state.filterDropdownValue}
            >
              {this.state.dataFiltered}
            </OsobeDrustvaTreceZemljeTable>
          </div>
        ) : null}

        <div>
          {this.state.isLoading ? (
            <Container style={{ display: "flex", justifyContent: "center" }}>
              <Row style={{ justifyContent: "center" }}>
                <Col style={{ alignItems: "center" }}>
                  <Spinner
                    animation="border"
                    variant="secondary"
                    style={{ marginTop: "16px", marginBottom: "16px" }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <div
                    style={{ marginTop: "16px", marginLeft: "16px" }}
                    className="spin-text"
                  >
                    <b>Učitavam...</b>
                  </div>
                </Col>
              </Row>
            </Container>
          ) : null}
          <div
            style={{
              width: "100%",
              justifyContent: "flex-end",
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            {this.state.totalPageCount != 0 ? (
              <Pagination
                defaultCurrent={1}
                current={this.state.registriSearchModel.pageNumber}
                defaultPageSize={this.state.registriSearchModel.offset}
                total={this.state.totalPageCount}
                showTotal={(total, range) =>
                  `Prikazano ${range[0]} do ${range[1]} od ${total} rezultata`
                }
                responsive
                onChange={this.pageChanged}
                showSizeChanger={false}
              />
            ) : null}
          </div>
        </div>

        <Modal
          show={this.state.modalVisible}
          onHide={(e) => this.hideModal("detalji")}
          size="xl"
          centered
          style={{ zIndex: "999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <iframe
            sandbox
            id="ifmcontentstoprint"
            style={{
              height: "0px",
              width: "0px",
              position: "absolute",
              display: "none",
            }}
          ></iframe>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <ReactToPrint
            trigger={() => {
              // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
              // to the root node of the returned component as it will be overwritten.
              return (
                <div>
                  <ButtonComponent
                    variant="secondary"
                    icon={<PrinterOutlined />}
                    className="print-btn"
                  >
                    Ispis
                  </ButtonComponent>
                </div>
              );
            }}
            content={() => this.componentRef}
          />
          </div>
          <div
            className="print-container"
            style={{ margin: "0", padding: "0" }}
            ref={(el) => (this.componentRef = el)}
          >
            <div className="page-break" />

            {this.getDetaljiTable()}
          </div>
        </Modal>

        <Modal
          show={this.state.povijestModalVisible}
          onHide={(e) => this.hideModal("povijest")}
          size="xl"
          centered
          style={{ zIndex: "999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <Table bordered hover responsive>
            <thead>
              <tr className="tr_table">
                <th scope="col">Datum izmjene</th>
                <th scope="col">Korisnik</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {this.state.povijestData.length > 0 ? (
                this.state.povijestData.map((el) => (
                  <tr key={el.id}>
                    <td>{moment(el.tstampUnosa).format("LLLL")}</td>
                    <td>
                      {el.ime && el.prezime
                        ? el.ime + " " + el.prezime
                        : noDataMessage}
                    </td>
                    <th scope="col">
                      <ButtonComponent
                        variant="primary"
                        onClick={(e) =>
                          this.detaljiClicked(el.id, el.vr, el.action, true)
                        }
                      >
                        PREGLEDAJ
                      </ButtonComponent>
                    </th>
                  </tr>
                ))
              ) : (
                <td colSpan="3">
                  <i>Nema dostupnih podataka.</i>
                </td>
              )}
            </tbody>
          </Table>
        </Modal>

        <Modal
          show={this.state.secondaryModalVisible}
          onHide={(e) => this.hideSecondaryModal()}
          size="xl"
          centered
          style={{ zIndex: "9999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          {this.getSecondaryDetaljiTable()}
        </Modal>

        <Modal
          show={this.state.deactivateModalVisible}
          onHide={(e) => this.hideModal("deaktivacija")}
          size="md"
          centered
          title="Deaktiviraj subjekt"
          style={{ zIndex: "999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <Fragment>
            <Container>
              <h6>Razlog brisanja subjekta:</h6>
              <InputComponent
                as="textarea"
                value={this.state.biljeska}
                onChange={this.handleInputChange}
                name="biljeska"
                rows={3}
                maxlength="2000"
                style={{ margin: 0, padding: 0 }}
              />
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <ButtonComponent
                  variant="primary"
                  onClick={this.deactivateSubjekt}
                  style={{ marginRight: "4px" }}
                >
                  Potvrdi
                </ButtonComponent>
                <ButtonComponent
                  variant="danger"
                  onClick={(e) => this.hideModal("deaktivacija")}
                >
                  Odustani
                </ButtonComponent>
              </div>
            </Container>
          </Fragment>
        </Modal>

        <Modal
          show={this.state.activateModalVisible}
          onHide={(e) => this.hideModal("aktivacija")}
          size="md"
          centered
          style={{ zIndex: "999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <Fragment>
            <Container>
              <Row>
                <Col>
                  {" "}
                  Jeste li sigurni da želite aktivirati obrisani subjekt?
                </Col>
                <Fragment>
                  <ButtonComponent
                    variant="primary"
                    onClick={this.activateSubjekt}
                    style={{ marginRight: "4px" }}
                  >
                    Da
                  </ButtonComponent>
                  <ButtonComponent
                    variant="danger"
                    onClick={(e) => this.hideModal("aktivacija")}
                  >
                    Ne
                  </ButtonComponent>
                </Fragment>
              </Row>
              <Row style={{ marginTop: "16px" }}></Row>
            </Container>
          </Fragment>
        </Modal>

        <Modal
          show={this.state.azurirajModalVisible}
          onHide={(e) => this.hideModal("azuriranje")}
          size="xl"
          centered
          style={{ zIndex: "999999" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <Table bordered hover responsive>
            <thead>
              <tr className="tr_table">
                <th scope="col">Oznaka dokumenta</th>
                <th scope="col">Registarski broj</th>
                <th scope="col">Naziv subjekta / Ime i prezime</th>
                <th scope="col">Ime i prezime podnositelja zahtjeva</th>
                {this.state.azuriranjeData.length > 0 ? (
                  <th scope="col"></th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {this.state.azuriranjeData.length > 0 ? (
                this.state.azuriranjeData.map((el) => (
                  <tr key={el.zahtjevAtrId}>
                    <td>{el.zahtjevAtrId}</td>
                    <td>{el.brReg}</td>
                    <td>
                      {el.nazivSubjekta
                        ? el.nazivSubjekta
                        : el.ime + el.prezime
                        ? el.ime + " " + el.prezime
                        : noDataMessage}
                    </td>
                    <td>
                      {!el.podnositeljIme && !el.podnositeljPrezime
                        ? noDataMessage
                        : !el.podnositeljPrezime
                        ? el.podnositeljIme
                        : !el.podnositeljIme
                        ? el.podnositeljPrezime
                        : el.podnositeljIme + " " + el.podnositeljPrezime}
                    </td>

                    <th scope="col">
                      <ButtonComponent
                        variant="primary"
                        onClick={(e) =>
                          this.redirectToAzurirajPoZahtjevu(
                            e,
                            this.state.idSubjekta,
                            this.state.vrSubjekta,
                            el.zahtjevAtrId
                          )
                        }
                      >
                        POSTUPAJ PO ZAHTJEVU
                      </ButtonComponent>
                    </th>
                  </tr>
                ))
              ) : (
                <td colSpan="7">
                  <i>
                    Za odabrani subjekt nije pronađen niti jedan prihvaćen
                    Zahtjev za upis promjene podataka u registru.
                  </i>
                </td>
              )}
            </tbody>
          </Table>
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchOsoba: (idOsobe, vrOsobe, oznDokumenta) =>
      dispatch({
        type: GET_OSOBA,
        idOsobe: idOsobe,
        vrOsobe: vrOsobe,
        oznDokumenta,
      }),
    dispatchDrustvo: (idDrustva, vrDrustva, oznDokumenta) =>
      dispatch({
        type: GET_DRUSTVO,
        idDrustva,
        vrDrustva,
        oznDokumenta,
      }),
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};

const mapStateToProps = (state) => {
  return {
    userData: state.authentication.userData,
    isAuthenticated: state.authentication.isAuthenticated,
    visionImpaired: state.layout.visionImpaired,
    fontSize: state.layout.fontSize,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PregledRegistra);
